import { createApp } from 'vue';
import App from './App.vue';
import './registerServiceWorker';
import router from './router';
import DataVVue3 from '@kjgl77/datav-vue3';

router.beforeEach((to, from, next) => {
  if (to.meta.title) {
    document.title = to.meta.title as string;
  }
  next();
});

createApp(App).use(DataVVue3).use(router).mount('#app');
